export class ImageLoader {
  constructor() {
  }

  /**
   * Use like this:
   *
   * loadImages(myImageUrlArray).then(images => {
   *   // the loaded images are in the images array
   * });
   *
   * Or inside an async function:
   *
   * const images = await loadImages(myImages);
   */
  async loadImages(imageDataArray, beforeLoad, onLoad, onError) {
    const promiseArray = []; // create an array for promises
    const imageArray = []; // array for the images
    for (let imageData of imageDataArray) {
      promiseArray.push(new Promise(resolve => {
        const img = new Image();
        /* If you don't need to do anything when the image loads,
        /* then you can just write img.onload = resolve. */
        img.onload = () => {
          if (onLoad) {
            onLoad(img, imageData);
          }
          // Resolve the promise, indicating that the image has been loaded.
          resolve();
        };
        img.onerror = () => {
          if (onError) {
            onError(img, imageData);
          }
          // Resolve the promise, indicating that the image has been processed.
          resolve();
        };
        if (beforeLoad) {
          // It's the beforeLoad function's responsibility to assign the
          // src property on the img.
          beforeLoad(img, imageData);
        } else {
          // We assume image Data is the url of the image
          img.src = imageData;
        }
        imageArray.push(img);
      }));
    }
    /* This is the bottom of a possibly long call stack of awaits!!! */
    await Promise.all(promiseArray); // wait for all the images to be loaded
    return imageArray;
  }

  async loadImage(imageUrl) {
    let img;
    const imageLoadPromise = new Promise(resolve => {
      img = new Image();
      img.onload = resolve;
      img.src = imageUrl;
    });
    await imageLoadPromise;
    return img;
  }
}
